import Nav from "../components/general/NavBar.jsx";
import Footer from "../components/general/footer.jsx";
import TypebotFrame from "../components/general/TypebotFrame.jsx";

const EvaluationInitialeBureautique = () => {
  return (
    <section>
      <Nav />
      <div style={{ width: "100%", minHeight: "600px" }}>
        <TypebotFrame slug="evaluation-bureautique-xo3ls11"/>
      </div>
      <Footer border="contact" />
    </section>
  );
};

export default EvaluationInitialeBureautique;